import { render, staticRenderFns } from "./layout-chat-main-v2.vue?vue&type=template&id=1dc839b7&scoped=true"
import script from "./layout-chat-main-v2.vue?vue&type=script&lang=js"
export * from "./layout-chat-main-v2.vue?vue&type=script&lang=js"
import style0 from "./layout-chat-main-v2.vue?vue&type=style&index=0&id=1dc839b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc839b7",
  null
  
)

export default component.exports